import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { PORTAL, USER_ROLE, type Portal, type UserRole } from '@core/models/auth.models';
import { AuthService } from '@core/services/auth.service';

export interface AccessRouteData {
  portal: Portal;
  allowAnonymous?: boolean;
  allowedRoles?: readonly UserRole[];
}

export const accessGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const data = route.data as AccessRouteData | undefined;
  const user = auth.currentSession();

  if (!data?.portal) {
    return router.createUrlTree([APP_ROUTES.ROOT]);
  }

  if (data.portal === PORTAL.PUBLIC) {
    return !user || user.role === USER_ROLE.CLIENT
      ? true
      : router.createUrlTree([APP_ROUTES.ADMIN]);
  }
  if (!user) {
    return data.allowAnonymous
      ? true
      : router.createUrlTree([APP_ROUTES.ADMIN_LOGIN], {
          queryParams: { returnUrl: state.url },
        });
  }
  if (user.role === USER_ROLE.CLIENT) {
    return router.createUrlTree([APP_ROUTES.ROOT]);
  }
  if (data.allowAnonymous) {
    return router.createUrlTree([APP_ROUTES.ADMIN]);
  }
  return !data.allowedRoles || data.allowedRoles.includes(user.role)
    ? true
    : router.createUrlTree([APP_ROUTES.ADMIN]);
};
